module.exports = __webpack_public_path__ + "static/media/daimler-wharf-2-cropped.d9faf09b.png";